// ФИО клиента для показа: части, в которых нет ни одной буквы или цифры, не выводим.
//
// В данных встречается фамилия «.» (у части клиентов, пришедших с сайтов и из Авито),
// а также «-», «..», «—» и т.п. — заглушки вместо пустого поля. Без фильтра колонка
// «Имя» показывает «. Стелла». Данные не правим, прячем только при показе.
// Часть вроде «Д.» или «Ли-Ян» остаётся: в ней есть буква.
const HAS_CONTENT = /[\p{L}\p{N}]/u;

export function isMeaningfulNamePart(part) {
  if (part == null) return false;
  const text = String(part).trim();
  return text !== "" && HAS_CONTENT.test(text);
}

export function personName(...parts) {
  return parts
    .filter(isMeaningfulNamePart)
    .map((part) => String(part).trim())
    .join(" ");
}

// Для клиента: {lastname, name, middlename}.
export function clientFullName(client) {
  if (!client) return "";
  return personName(client.lastname, client.name, client.middlename);
}
